import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustryRetailPayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
